<template>
  <div class="header">
    <a href="/">P H O T O  A I</a>
    <a href="#what-we-do" class="item">
      About Us
    </a>
    <a href="#company" class="item">
      Branding
    </a>
    <a href="#influencer" class="item">
      Influencers
    </a>
    <a href="#hello" class="item">
      Marketing
    </a>
  </div>
</template>

<script>
export default {
  name: 'TitleHeader',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    font-size: 16px;
    width: 100%;
    padding: 20px;
    margin-top: 0px;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    text-align: left;
    color: #267df4;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    background-color: #fff;
    font-weight: bold;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  .item {
    font-weight: normal;
    float: right;
    margin-left: 30px;

  }
  i {
    color: pink;
  }
  .small {
    font-size: 14px;
    font-weight: normal;
    line-height: 16px;
    display: inline-block;
    margin-top: 20px;
  }
@media only screen and (max-width: 900px) {
  .item {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TitleHeader.vue